<template>
  <vue-scroll
    class="luttica-scroll-bar"
    :ops="ops"
    :style="style"
    @handle-scroll="handleScroll"
    @handle-resize="handleResize"
    ref="vueScroll"
  >
    <div :id="id" v-if="id">
      <slot></slot>
    </div>
    <slot v-else :id="id"></slot>
  </vue-scroll>
</template>

<script>
import vueScroll from 'vuescroll';

export default {
  name: 'index',
  components: {
    vueScroll,
  },
  props: {
    height: String,
    maxHeight: String,
    minWidth: String,
    width: String,
    visible: {
      type: Boolean,
      default: true,
    },
    keepShow: {
      type: Boolean,
      default: true,
    },
    scrollingX: {
      type: Boolean,
      default: true,
    },
    scrollingY: {
      type: Boolean,
      default: true,
    },
    modalVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollLeft: 0,
      scrollTop: 0,
      id: '',
      cloneHeight: 0,
    };
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    this.id = `${this._uid}_scroll`;
  },
  mounted() {
    this.initMaxHeight();
    if (this.scrollingX) {
      this.$el.addEventListener('wheel', this.handleWheel, { passive: false });
    }
  },
  beforeDestroy() {
    if (this.scrollingX) {
      this.$el.removeEventListener('wheel', this.handleWheel);
    }
  },
  watch: {
    /*
      这个监听应该是不起作用的，原因是modal组件中优化时将
      body这一部分加载与否与visible绑定了
    */
    modalVisible(val) {
      if (val && this.maxHeight) {
        this.initMaxHeight();
      }
    },
    style(val) {
      if (val) {
        this.$refs.vueScroll.refresh();
      }
    },
  },
  computed: {
    style() {
      const newHeight = this.height ? `${this.height} !important` : '100%';
      const newWidth = this.width ? `${this.width} !important` : '100%';
      const minWidth = this.minWidth ? `${this.minWidth} !important` : 'unset';
      if (this.maxHeight) {
        if (window.parseInt(this.maxHeight) > this.cloneHeight) {
          return { width: newWidth, minWidth, height: `${this.cloneHeight}px` };
        }
        return { width: newWidth, minWidth, height: this.maxHeight };
      }
      // 如果没有maxHeight, 则正常返回
      return { width: newWidth, minWidth, height: newHeight };
    },
    ops() {
      return {
        vuescroll: {
          // sizeStrategy: 'number',
        },
        scrollPanel: {
          scrollingY: this.scrollingY,
          scrollingX: this.scrollingX,
          initialScrollY: false,
          initialScrollX: false,
        },
        bar: {
          background: '#3399FF',
          onlyShowBarOnScroll: false,
          keepShow: this.keepShow,
          size: this.visible ? '8px' : 0,
          minSize: 0.1,
          // transition: opacity
        },
        rail: {
          opacity: 0.8,
          background: 'transparent',
          gutterOfSide: '1px',
          size: this.visible ? '10px' : 0,
        },
        scrollButton: {
          enable: false,
          background: '#cecece',
        },
      };
    },
  },
  methods: {
    initMaxHeight() {
      if (this.maxHeight) {
        const ele = document.getElementById(`${this.id}`).cloneNode(true);
        ele.id = `${this.id}_clone`;
        document.getElementById(`${this.id}`).parentNode.appendChild(ele);
        this.cloneHeight = window.$(`#${this.id}_clone`).outerHeight(true);
        this.$nextTick(() => {
          document
            .getElementById(`${this.id}`)
            .parentNode.removeChild(document.getElementById(`${this.id}_clone`));
        });
      }
    },
    handleScroll(vertical, horizontal, nativeEvent) {
      this.scrollLeft = horizontal.scrollLeft;
      this.scrollTop = vertical.scrollTop;
      this.$emit('handle-scroll', vertical, horizontal, nativeEvent);
    },
    scrollTo(position, speed = 5, easing) {
      this.$refs.vueScroll.scrollTo(position, 0, undefined);
    },
    scrollBy(position, speed = 5, easing) {
      this.$refs.vueScroll.scrollBy(position, 0, undefined);
    },
    getScrollPosition() {
      return {
        scrollLeft: this.scrollLeft,
        scrollTop: this.scrollTop,
      };
    },
    refresh(val) {
      // 某些情况下需要滚动条保持不动
      if (val === 'noChange') {
        this.$refs.vueScroll.refresh();
      } else if (val === 'noChangeX') {
        this.$refs.vueScroll.scrollTo({ y: 0 }, 300);
        this.$refs.vueScroll.refresh();
      } else if (val === 'noChangeY') {
        this.$refs.vueScroll.scrollTo({ x: 0 }, 300);
        this.$refs.vueScroll.refresh();
      } else {
        this.$refs.vueScroll.scrollTo({ x: 0 }, 300);
        this.$refs.vueScroll.scrollTo({ y: 0 }, 300);
        this.$refs.vueScroll.refresh();
      }
    },
    handleResize(val) {
      this.initMaxHeight();
    },
    /**
     * vuescroll slide 模式不处理 wheel 的 deltaX，触控板横向滑动无效。
     * 在启用横向滚动时补接 wheel 事件。
     */
    handleWheel(event) {
      let { deltaX, deltaY, shiftKey } = event;
      if (shiftKey && Math.abs(deltaY) > Math.abs(deltaX)) {
        deltaX = deltaY;
        deltaY = 0;
      }
      if (Math.abs(deltaX) <= Math.abs(deltaY) || !this.scrollingX) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (this.$refs.vueScroll) {
        this.$refs.vueScroll.scrollBy({ dx: deltaX }, 0);
      }
    },
  },
};
</script>

<style lang="less">
.luttica-scroll-bar {
  .__rail-is-horizontal {
    z-index: 999 !important;
  }

  .__rail-is-vertical {
    z-index: 999 !important;
  }
}
</style>
